import { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from '/utilities/i18n';

import omit from 'lodash/omit';

// Partials
import Select from '/views/partials/select';

const baseProps = {
	openMenuOnFocus: true,
};

const SelectInput = ({
	onChangePlainValue,
	onChange,
	className,
	label,
	validationError,
	value,
	disabled,
	innerContent,
	wrapperId,
	...rawProps
}) => {
	const { t } = useTranslation();

	const plainValue = useMemo(() => {
		return value?.value ? value?.value.toString() : '';
	}, [value]);

	const props = useMemo(
		() => ({
			...baseProps,
			noOptionsMessage: t('Seçenek yok.'),
			...rawProps,
		}),
		[rawProps]
	);

	const isFull = useMemo(() => !!plainValue?.length, [plainValue]);

	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		onChangePlainValue(plainValue);
	}, [plainValue]);

	const handleChange = (newVal) => {
		onChange(newVal);
	};

	const { ...computedProps } = useMemo(() => {
		let computedProps = {
			...omit(props, [
				'innerContent',
				'onChange',
				'placeholder',
				'value',
				'popLabel',
				'validation',
				'touched',
				'className',
				'hideError',
				'onFeedback',
				'elemClass',
				'initialized',
			]),
			value: value,
			placeholder: label,
			disabled,
			onChange: handleChange,
			onOpenstateChange: setIsOpen,
			className: props.elemClass ? props.elemClass : undefined,
		};

		return computedProps;
	}, [label, value, handleChange, props, disabled]);

	return (
		<div className={classNames(className, { 'input-full': isFull, 'select-open': isOpen })} id={wrapperId}>
			<div className={'inputwrap-outerwrap' + (label ? '' : ' no-label')}>
				{label && (
					<label className="input-label" htmlFor={props.id}>
						<div className="label-text">
							{label}
							{/* {((vm.props.validation !== false && vm.props.validation.required) && vm.props.showValidationAsterisk) && <span className="label-asterisk">*</span>} */}
						</div>
					</label>
				)}
				<div className="input-innerwrap">
					{innerContent}
					<Select {...computedProps} />
				</div>
			</div>
			{!!(validationError && !props.hideError) && (
				<div className="input-error">{validationError}</div>
			)}
		</div>
	);
};

export default SelectInput;
